import './Footer.css';
import logo from '../../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <div className="footer__logo-row">
            <img
              className="footer__logo-img"
              src={logo}
              alt="Articsystems"
            />
          </div>
          <p className="footer__tagline">
            Our automated systems deliver continuous performance with real-time monitoring, adaptive
            navigation, seamless integration, and proactive operational intelligence.
          </p>
          {/* <div className="footer__socials">
            <a href="#" className="footer__social-link" aria-label="LinkedIn">
              <svg viewBox="0 0 20 20" fill="none">
                <rect x="2" y="2" width="16" height="16" rx="3" stroke="#90a1b9" strokeWidth="1.3" />
                <path
                  d="M6 8.5v5M6 6v.01M10 13.5v-3a1.5 1.5 0 013 0v3M10 8.5v5"
                  stroke="#90a1b9"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                />
              </svg>
            </a>
            <a href="#" className="footer__social-link" aria-label="X / Twitter">
              <svg viewBox="0 0 20 20" fill="none">
                <path
                  d="M3 3.5h3.5l3 5-3.5 4H7.5l2.8-3.4L13.5 12.5H17l-3.5-5L16.5 3.5H15L12.3 7 9.5 3.5H3z"
                  stroke="#90a1b9"
                  strokeWidth="1.1"
                  fill="none"
                />
              </svg>
            </a>
            <a href="#" className="footer__social-link" aria-label="Instagram">
              <svg viewBox="0 0 20 20" fill="none">
                <rect x="3" y="3" width="14" height="14" rx="4" stroke="#90a1b9" strokeWidth="1.3" />
                <circle cx="10" cy="10" r="3" stroke="#90a1b9" strokeWidth="1.3" />
                <circle cx="14.2" cy="5.8" r=".9" fill="#90a1b9" />
              </svg>
            </a>
            <a href="#" className="footer__social-link" aria-label="YouTube">
              <svg viewBox="0 0 20 20" fill="none">
                <rect x="2" y="5" width="16" height="10" rx="3" stroke="#90a1b9" strokeWidth="1.3" />
                <path
                  d="M8 7.5l5 2.5-5 2.5V7.5z"
                  stroke="#90a1b9"
                  strokeWidth="1.2"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div> */}
        </div>

        <div className="footer__col">
          <h4>Company</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/engineering-services">Engineering Services</a></li>
            <li><a href="/manufacturing">Manufacturing</a></li>
          </ul>
        </div>

        <div className="footer__col">
    <h4>Location</h4>

          <div className="footer__map-box">
            <iframe
              src="https://maps.google.com/maps?q=13.0939233,80.1243667&z=15&output=embed"
              width="100%"
              height="100%"
              className="footer__map-iframe"
              loading="lazy"
              title="location"
            ></iframe>
          </div>
        </div>

        <div className="footer__col">
          <h4>Contact Info</h4>
          <div className="footer__contact-row">

            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
                stroke="#90a1b9"
                strokeWidth="1.2"
                fill="none" />
              <circle cx="12" cy="10" r="3"
                stroke="#90a1b9"
                strokeWidth="1.2"
                fill="none" />
            </svg>
            <span>No.42/43 Jeevarathinam Nagar, Ayapakkam, Chennai - 600077, Tamil Nadu, India</span>
          </div>
          <div className="footer__contact-row">
            <svg viewBox="0 0 20 20">
              <g clip-path="url(#clip0_630_789)">
                <path d="M11.5265 13.807C11.6986 13.886 11.8925 13.9041 12.0762 13.8582C12.26 13.8123 12.4226 13.7052 12.5373 13.5545L12.8332 13.167C12.9884 12.96 13.1897 12.792 13.4211 12.6763C13.6526 12.5606 13.9078 12.5003 14.1665 12.5003H16.6665C17.1085 12.5003 17.5325 12.6759 17.845 12.9885C18.1576 13.301 18.3332 13.725 18.3332 14.167V16.667C18.3332 17.109 18.1576 17.5329 17.845 17.8455C17.5325 18.1581 17.1085 18.3337 16.6665 18.3337C12.6883 18.3337 8.87295 16.7533 6.0599 13.9403C3.24686 11.1272 1.6665 7.31191 1.6665 3.33366C1.6665 2.89163 1.8421 2.46771 2.15466 2.15515C2.46722 1.84259 2.89114 1.66699 3.33317 1.66699H5.83317C6.2752 1.66699 6.69912 1.84259 7.01168 2.15515C7.32424 2.46771 7.49984 2.89163 7.49984 3.33366V5.83366C7.49984 6.0924 7.4396 6.34759 7.32388 6.57901C7.20817 6.81044 7.04016 7.01175 6.83317 7.16699L6.44317 7.45949C6.29018 7.57631 6.18235 7.74248 6.138 7.92978C6.09364 8.11709 6.11549 8.31397 6.19984 8.48699C7.33874 10.8002 9.21186 12.671 11.5265 13.807Z"
                  stroke="#90a1b9"
                  strokeWidth="1.2"
                  fill="none" />
              </g>
              <defs>
                <clipPath id="clip0_630_789">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span>+91 87784 00101</span>
          </div>
          <div className="footer__contact-row">
            <svg viewBox="0 0 20 20" fill="none">
              <path
                d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                stroke="#90a1b9"
                strokeWidth="1.2"
              />
              <path d="M3 6l7 5 7-5" stroke="#90a1b9" strokeWidth="1.2" />
            </svg>
            <span>info@articsystems.com</span>
          </div>
        </div>
      </div>
      

      <div className="footer__bottom">
        <p>© 2026 Articz Systems Private Limited. All rights reserved.</p>
        <div className="footer__bottom-right">
          <span>🇮🇳 Made in India</span>
          {/* <span>ISO 9001:2015</span> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;